import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  forwardRef,
  inject,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'finxone-platform-slider',
  templateUrl: './finxone-slider.component.html',
  styleUrls: ['./finxone-slider.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FinxoneSliderComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FinxoneSliderComponent implements ControlValueAccessor {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  @Input() min = 0;
  @Input() max = 100;
  @Input() step = 1;
  @Input() disabled = false;
  @Input() label = '';

  public value = 0;

  // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-empty-function
  public onModelChange: Function = () => {};
  // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-empty-function
  public onModelTouched: Function = () => {};

  public rangeWidth = 0;

  public writeValue(value: number): void {
    if (value !== undefined && value !== null) {
      this.value = value;
      this.changeDetectorRef.markForCheck();
    }
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  public registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  public registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.changeDetectorRef.markForCheck();
  }

  public onSliderValueChange(newValue: number): void {
    this.value = newValue;
    // Emitting the first element for single slider compatibility, or array if multiple handles
    const emittedValue = newValue;
    this.onModelChange(emittedValue);
    this.onModelTouched();
  }
}
